import { render } from "./EditSentNoteGlobal.vue?vue&type=template&id=3b83b676&ts=true"
import script from "./EditSentNoteGlobal.vue?vue&type=script&lang=ts"
export * from "./EditSentNoteGlobal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__